import { useState, useEffect, useRef } from 'preact/hooks';
import axios from 'axios';

function useDrawing(uuid, configuration) {
  const [xml, setXml] = useState(null);
  const isXmlConfigured = useRef(false);

  useEffect(() => {
    async function configureXml() {
      if (uuid) {
        try {
          const response = await axios.get(`/api/v1/drawings/${uuid}`, {
            headers: {
              Authorization: `Bearer ${configuration.authentication.jwt}`,
            },
          });
          setXml(response.data.xml);
        } catch (error) {
          console.error(error.message);
        }
      } else if (configuration?.xml) {
        setXml(configuration.xml);
      } else {
        setXml('');
      }
      isXmlConfigured.current = true;
    }

    (async () => {
      if(configuration?.authentication && !isXmlConfigured.current) {
        await configureXml();
      }
    })();
  }, [uuid, configuration]);

  return xml;
}

export default useDrawing;
